'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["title", "children", "type"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIAlert from 'UIComponents/alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTipAlert = styled(UIAlert).withConfig({
  displayName: "TipAlert__StyledTipAlert",
  componentId: "sc-11mheyi-0"
})(["border-radius:3px;"]);
const TipAlertTitle = styled.span.withConfig({
  displayName: "TipAlert__TipAlertTitle",
  componentId: "sc-11mheyi-1"
})(["font-weight:800;margin-left:2px;margin-right:2px;"]);
export default function TipAlert(props) {
  const {
      title,
      children,
      type
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs(StyledTipAlert, Object.assign({}, rest, {
    className: "m-top-4",
    type: type,
    use: "inline",
    children: [title && /*#__PURE__*/_jsx(TipAlertTitle, {
      children: `${title}: `
    }), children]
  }));
}
TipAlert.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node.isRequired,
  type: PropTypes.string
};
TipAlert.defaultProps = {
  type: 'info'
};